import { ProcessData } from "@/pages/caster/models/ProcessData";
import { Link, LinkOff } from "@mui/icons-material";
import { CircularProgress, IconButton } from "@mui/material";

interface LinkUnlinkButtonProps {
	process: ProcessData;
	onButtonClick: () => void;
	loading: boolean;
}

export const LinkUnlinkButton = ({
	process,
	onButtonClick,
	loading,
}: LinkUnlinkButtonProps) => {
	return (
		<>
			<IconButton
				size={"small"}
				title={process.HeatId ? "Unlink" : "Link"}
				onClick={onButtonClick}
				style={{
					color: process.HeatId ? "red" : "#3f51b5",
				}}
			>
				{loading ? (
					<CircularProgress size="1.5rem" />
				) : process?.HeatId === null ? (
					<Link style={{ cursor: "pointer" }} />
				) : (
					<LinkOff style={{ cursor: "pointer" }} />
				)}
			</IconButton>
		</>
	);
};
